import {DashboardActions} from "../../../actions";
import {standardFormat} from "../../../utils";
import {firstDayMonth, lastDayMonth} from "../../../utils";

export const getCommercialTabData = async (
    userData,
    notify,
    setLoading,
    setSalesActivity,
    commercialBalanceDatePicker,
    setSalesOverview
) => {
    // ↓ «Indicateurs d‘activité» data
    const salesActivityResult = await DashboardActions.CodevActions.getSalesActivity(userData, "");

    if (salesActivityResult.success) {
        setSalesActivity(salesActivityResult.data);
    }
    else {
        notify("Une erreur est survenue lors de la récuperation des indicateurs d'activité commercial");
    }

    // ↓ «Bilan commercial» data
    const salesOverviewResult = await DashboardActions.CodevActions.getSalesOverview(
        userData,
        `?start_date=${standardFormat(commercialBalanceDatePicker.startDate)}&end_date=${standardFormat(commercialBalanceDatePicker.endDate)}`
    );

    if (salesOverviewResult.success) {
        setSalesOverview(salesOverviewResult.data);
    }
    else {
        notify("Une erreur est survenue lors de la récuperation des bilan commercial");
    }

    setLoading(false);
}

export const handleCommercialBalanceDatePickerChange = async (
    e,
    userData,
    notify,
    setLoading,
    setCommercialBalanceDatePicker,
    setSalesOverview
) => {
    setLoading(true);

    const dates = {
        startDate: e.startDate ? e.startDate : firstDayMonth(new Date()),
        endDate: e.endDate ? e.endDate : lastDayMonth(new Date())
    };

    setCommercialBalanceDatePicker(dates);

    const salesOverviewResult = await DashboardActions.CodevActions.getSalesOverview(
        userData,
        `?after=${standardFormat(dates.startDate)}&before=${standardFormat(dates.endDate)}`
    );

    if (salesOverviewResult.success) {
        setSalesOverview(salesOverviewResult.data);
    }
    else {
        notify("Une erreur est survenue lors de la récuperation des bilan commercial");
    }

    setLoading(false);
};
